import { PHOTO_TIME, PHOTO_TIME_NUM } from "../constants"

class TimestampElement {
  constructor(containerElement, timeElement) {
    this.containerElement = containerElement
    this.timeElement = timeElement
  }

  static fromHtmlElement(htmlElement) {
    const containerElement = htmlElement.querySelector(PHOTO_TIME)
    if (!containerElement) return null

    const timeElement = containerElement.querySelector(PHOTO_TIME_NUM)
    return new TimestampElement(containerElement, timeElement)
  }

  // Format timestamp similar to human_friendly_timestamp helper
  formatDateTime(timestamp) {
    return new Date(timestamp).toLocaleString("en-US", {
      hours12: true,
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
  }

  apply(photo) {
    if (!this.timeElement) return

    if (photo.timestamp) {
      this.timeElement.dataset.date = photo.timestamp
      // Update the displayed text
      this.timeElement.textContent = this.formatDateTime(photo.timestamp)

      // Show the container if it was hidden
      if (this.containerElement) {
        this.containerElement.classList.remove("is-hidden")
      }
    } else {
      // Hide the container if no timestamp
      if (this.containerElement) {
        this.containerElement.classList.add("is-hidden")
      }
    }
  }
}

export default TimestampElement
